import { useState, useEffect } from 'react';

const STORAGE_KEY = 'evinly_disclaimer_accepted';
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export default function DisclaimerModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const ts = parseInt(stored, 10);
      if (Date.now() - ts < THIRTY_DAYS_MS) return;
    }
    setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-slate-900 shader:bg-black/40 shader:backdrop-blur-2xl shader:border shader:border-white/10 rounded-2xl shadow-2xl max-w-lg w-full p-6 md:p-8 animate-fade-in">
        <div className="text-center mb-5">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-violet-100 dark:bg-violet-900/30 mb-3">
            <svg className="w-6 h-6 text-violet-600 dark:text-violet-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
          </div>
          <h2 className="font-display text-lg text-slate-900 dark:text-white">
            Information importante
          </h2>
        </div>

        <div className="space-y-3 text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
          <p>
            <strong className="text-slate-900 dark:text-white">Evinly est un outil d'aide
            &agrave; la d&eacute;cision.</strong> Il vous permet d'&eacute;valuer la conformit&eacute;
            de vos contenus &agrave; la Loi &Eacute;vin et de mieux comprendre les r&egrave;gles
            applicables &agrave; la publicit&eacute; des boissons alcoolis&eacute;es.
          </p>
          <p>
            Cependant, <strong className="text-slate-900 dark:text-white">cet outil ne se substitue
            en aucun cas &agrave; l'avis d'un avocat sp&eacute;cialis&eacute;</strong> en droit de
            la publicit&eacute; des boissons alcoolis&eacute;es. Les analyses fournies sont
            indicatives et ne constituent ni un avis juridique, ni une garantie de conformit&eacute;.
          </p>
          <p>
            Que vous soyez une marque, une agence, un cr&eacute;ateur de contenu ou tout autre
            professionnel, <strong className="text-slate-900 dark:text-white">toute d&eacute;cision
            engageant votre responsabilit&eacute; juridique doit &ecirc;tre valid&eacute;e par un
            professionnel du droit</strong>.
          </p>
        </div>

        <button
          onClick={accept}
          className="font-display mt-6 w-full py-3 rounded-xl text-white bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 shader:from-white shader:to-white shader:text-slate-900 shader:hover:from-white/90 shader:hover:to-white/90 transition-all"
        >
          J'ai compris et j'accepte
        </button>

        <p className="mt-3 text-center text-[10px] text-slate-400 dark:text-slate-500">
          Ce message s'affiche une fois par mois.
        </p>
      </div>
    </div>
  );
}
